import { Choice } from '@epicuro-next/ataraxia/modal';
import { MessagePosition, MessageType } from '@epicuro-next/ataraxia/snack-bar';
import { createActionGroup, props } from '@ngrx/store';

export { MessageType, MessagePosition };

export const modalActionGroup = createActionGroup({
  source: 'Modal',
  events: {
    answer: props<{
      answer: Choice['value'];
    }>(),
    show: props<{
      choices: Choice[];
      message: string;
      title?: string;
      noAnswerValue: Choice['value'];
    }>(),
  },
});
